module.exports = __webpack_public_path__ + "img/02942192000695.86376036.png";